import "./App.css";
import { NotificationsProvider } from "@mantine/notifications";
import { MantineProvider, ColorSchemeProvider } from "@mantine/core";
import Home from "./Pages/Home";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Dashboard from "./Pages/Dashboard";
import Learnmore from "./Pages/Learnmore";
import { useLocalStorage, useHotkeys } from "@mantine/hooks";
import { useEffect } from "react";

function App() {
    const year=process.env.REACT_APP_CURRENT_YEAR;
  useEffect(()=>{
    document.title = `Spider Inductions ${year}`
  }, [])
  const [colorScheme, setColorScheme] = useLocalStorage({
    key: "mantine-color-scheme",
    defaultValue: "dark",
    getInitialValueInEffect: true,
  });

  const toggleColorScheme = (value) =>
    setColorScheme(value || (colorScheme === "dark" ? "light" : "dark"));

  useHotkeys([["mod+J", () => toggleColorScheme()]]);

  return (
    <>
      <NotificationsProvider>
        <ColorSchemeProvider
          colorScheme={colorScheme}
          toggleColorScheme={toggleColorScheme}
        >
          <MantineProvider
            theme={{ colorScheme }}
            withGlobalStyles
            withNormalizeCSS
          >
            <Router>
              <Switch>
                <Route path="/" exact component={Home} />
                <Route path="/dashboard" component={Dashboard} />
                <Route path="/learnmore/:id" component={Learnmore} />
              </Switch>
            </Router>
          </MantineProvider>
        </ColorSchemeProvider>
      </NotificationsProvider>
    </>
  );
}

export default App;
